export default __webpack_public_path__ + "static/media/Children_Cheering.4ccc5c0b.wav";